import ElyfHeroFrame1 from './elyfFrame1.jpg'
import ElyfHeroFrame2 from './elyfFrame2.jpg'
import ElyfHeroFrame3 from './elyfFrame3.jpg'
import ElyfDifferenceChart from './elyfDifferenceChart.png'
import ElyfDifferenceChartWithContent from './elyfDifferenceChartWithContent.png'
import BottomHeroCurve from './bottomHeroCurv1.png'
import TopHeroCurve from './TopHeroCurve1.png'
import CurriculumFrame1 from './curriculumFrame1.png'
import CurriculumFrame2 from './curriculumFrame2.png'
import ColorPalleteIcon from './colorPallete.png'
import HandShakeIcon from './handShake.png'
import BulbIcon from './bulb.png'
import PeoplesIcon from './peoples.png'
import AboutElyfFrame1 from  './aboutElyfFrame1.jpg'
import AboutElyfFrame2 from  './aboutElyfFrame2.jpg'
import AboutElyfFrame3 from  './aboutElyfFrame3.jpg'
import AboutElyfFrame4 from  './aboutElyfFrame4.jpg'

export const EducationForLifeImages = {

  ElyfHeroFrame1,
  ElyfHeroFrame2,
  ElyfHeroFrame3,
  ElyfDifferenceChart,
  BottomHeroCurve,
  TopHeroCurve,
  CurriculumFrame1,
  CurriculumFrame2,
  ColorPalleteIcon,
  HandShakeIcon,
  BulbIcon,
  PeoplesIcon,
  AboutElyfFrame1,
  AboutElyfFrame2,
  AboutElyfFrame3,
  AboutElyfFrame4,
  ElyfDifferenceChartWithContent

    

}
